export const zIndex = {
    header: 25,
    mobileNav: 20,
    topBar: 1100,
    aboveTopBar: 1101,
    overlay: 1105,
    aboveOverlay: 1106,
    announcementBanner: 1201,
};
